var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 480L32 512H96L128 480L160 512H224L256 480L288 512H352L384 480L416 512H480L512 480V448H0V480ZM352 80V16C352 7.25 344.75 0 336 0H16C7.25 0 0 7.25 0 16V96H336C344.75 96 352 88.75 352 80ZM439.25 285.75L320 256H272C263.2 256 256 248.8 256 240V240C256 231.2 263.2 224 272 224H320V192H272C263.2 192 256 184.8 256 176V176C256 167.2 263.2 160 272 160H320V128H0V416H512V379C512 334.875 481.999 296.5 439.25 285.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoot);
export default __webpack_public_path__ + "static/media/boot.f6cfd73662be14a4e851ebcbe75c049b.svg";
export { ForwardRef as ReactComponent };